import { render, staticRenderFns } from "./SectionEdit.vue?vue&type=template&id=0b9e1aef&"
import script from "./SectionEdit.vue?vue&type=script&lang=js&"
export * from "./SectionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports